module.exports = __webpack_public_path__ + "img/jagopack-badge.0ba3201f.svg";